import { https , httpsFile } from './http.js' ;

export function index () {
    return https().get( 'vendors' );
}
export function searchVendor (search,offset) {
    return https().get( `searchVendor?search=${search}&offset=${offset}` );
}
export function getSupplierRecommendation (page,currentpage, search) {
    return https().get( `getSupplierRecommendation?page=${page}&currentpage=${currentpage}&search=${search}` );
}
export function deleteSupplierRecommendation (data) {
    return https().post( `deleteSupplierRecommendation`,data );
}
export function addSupplierRecommendation (data) {
    return https().post( `addSupplierRecommendation`,data );
}